const delayedRenderStep = 10;

export default delayedRenderStep;



// WEBPACK FOOTER //
// ./src/config/delayedRenderStep.js